import { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { TableCell, TableContainer, TableHead, TableRow, Table, TableBody, Box, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import Paper from '@mui/material/Paper'
import MenuItem from '@mui/material/MenuItem'
import { colors } from 'constants/theme';

/** STYLE */
import useStyles from 'features/setting/personnel-managements/personnels/style'
import * as UseStyled from 'features/setting/personnel-managements/personnels/useStyles'

/** UTILS || SLICE */
import { selectLoadingEducation, editEducation, selectEducation } from 'app/slice/user.slice';

/** CONSTANT */

/** COMPONENT */
import BasicSelect from 'component/Select/BasicSelect'
import { ButtonDeleteSimple } from 'component/Button/ButtonDelete'
import TextInput from 'new-components/inputs/text-input';
import SelectInput from 'new-components/inputs/select-input';

const educationTypes = [
  { name: 'EDUCATION_QUALIFICATION', id_type: 1 },
  { name: 'TRAINING_COURSE', id_type: 2 },
  { name: 'CERTIFICATE', id_type: 2 }
]
interface UserBackgroundType {
  backgroundType: string
  name: string
  institute: string
  year: string
  refId: number
}


interface EducationProps {
  isEdit: boolean
}
export default function Education(props: EducationProps) {
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const userEducation = useSelector(selectEducation)
  const loading = useSelector(selectLoadingEducation)
  const [userBackground, setUserBackground] = useState<UserBackgroundType[]>([])
  const headTable = [t('PERSONNEL.EDUCATION.TYPE_EDUCATION'), t('PERSONNEL.EDUCATION.EDUCATION_NAME'), t('PERSONNEL.EDUCATION.INSTITUTION'), t('PERSONNEL.EDUCATION.YEAR_OF_GRADUATION'), 'Action']

  useEffect(() => {
    if (!loading) {
      if (props.isEdit) setUserBackground(userEducation.userBackgrounds)
    }
  }, [loading])

  return (
    <Box sx={{ p: 3, overflow: 'auto' }}>
      <Typography sx={{ fontSize: 20, fontWeight: 600, ml: 1, mt: 2 }}>
        {t('PERSONNEL.EDUCATION.EDUCATION_RECORD')}
      </Typography>
      <TableContainer component={Paper} sx={{ mt: 3, boxShadow: 'none', border: `1px solid ${colors.lightGray}` }} >
        <Table aria-label="education record table" sx={{ minWidth: 900 }}>
          <TableHead>
            <TableRow>
              {headTable.map((title, i) => (
                <TableCell key={i} sx={{ color: '#fff', bgcolor: '#2F4269' }}>
                  <Typography sx={{ fontWeight: 600, color: '#fff' }}>
                    {title}
                  </Typography>
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell
                colSpan={5}
                onClick={() =>
                  setUserBackground(prev => [
                    ...prev,
                    { refId: prev.length, backgroundType: '', name: '', institute: '', year: '' }
                  ])
                }
                sx={{
                  backgroundColor: 'transparent !important',
                  cursor: 'pointer',
                  '&:hover': { backgroundColor: colors.extraLightBlue }
                }}
              >
                <UseStyled.DivAdd>
                  + {t('PERSONNEL.EDUCATION.ADD_EDUCATION')}
                </UseStyled.DivAdd>
              </TableCell>
            </TableRow>
            {/* Existing education records */}
            {userBackground.map(({ refId, backgroundType, name, institute, year }) => (
              <TableRow key={refId}>
                <TableCell>
                  <SelectInput
                    label={t('PERSONNEL.EDUCATION.TYPE_EDUCATION')}
                    value={backgroundType}
                    onChange={e => {
                      const v = e.target.value;
                      const updated = userBackground.map(obj =>
                        obj.refId === refId ? { ...obj, backgroundType: v } : obj
                      );
                      setUserBackground(updated);
                      dispatch(editEducation({ value: updated, key: 'userBackgrounds' }));
                    }}
                    options={educationTypes.map(({ name, id_type }) => ({
                      value: name,
                      name: t(`PERSONNEL.INPUT.${name}`)
                    }))}
                    width="100%"
                  />
                </TableCell>
                <TableCell>
                  <TextInput
                    label={
                      backgroundType
                        ? t(`PERSONNEL.INPUT.${backgroundType}`)
                        : t('PERSONNEL.EDUCATION.EDUCATION_QUALIFICATION')
                    }
                    value={name}
                    onChange={e => {
                      const updated = userBackground.map(obj =>
                        obj.refId === refId ? { ...obj, name: e.target.value } : obj
                      );
                      setUserBackground(updated);
                      dispatch(editEducation({ value: updated, key: 'userBackgrounds' }));
                    }}
                    fullWidth
                  />
                </TableCell>
                <TableCell>
                  <TextInput
                    label={t('PERSONNEL.EDUCATION.INSTITUTION')}
                    value={institute}
                    onChange={e => {
                      const updated = userBackground.map(obj =>
                        obj.refId === refId ? { ...obj, institute: e.target.value } : obj
                      );
                      setUserBackground(updated);
                      dispatch(editEducation({ value: updated, key: 'userBackgrounds' }));
                    }}
                    fullWidth
                  />
                </TableCell>
                <TableCell>
                  <TextInput
                    label={t('PERSONNEL.EDUCATION.YEAR_OF_GRADUATION')}
                    value={year}
                    onChange={e => {
                      const updated = userBackground.map(obj =>
                        obj.refId === refId ? { ...obj, year: e.target.value } : obj
                      );
                      setUserBackground(updated);
                      dispatch(editEducation({ value: updated, key: 'userBackgrounds' }));
                    }}
                    fullWidth
                  />
                </TableCell>
                <TableCell
                  onClick={() => {
                    const filtered = userBackground.filter(obj => obj.refId !== refId);
                    setUserBackground(filtered);
                    dispatch(editEducation({ value: filtered, key: 'userBackgrounds' }));
                  }}
                  sx={{ cursor: 'pointer' }}
                >
                  <ButtonDeleteSimple />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  )
}
